module.exports = __webpack_public_path__ + "img/xianghu.8db2f523.svg";